export function normalizeGuideHeading(heading) {
  return heading.replace(/^\d+\.\s+/, '').trim();
}

export function slugifyGuideHeading(heading) {
  return normalizeGuideHeading(heading)
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function guideSectionPresentation(heading, index) {
  const normalizedHeading = normalizeGuideHeading(heading);
  const slug = slugifyGuideHeading(heading) || `section-${index + 1}`;

  return {
    heading: normalizedHeading,
    id: `guide-${slug}`,
    indexLabel: String(index + 1).padStart(2, '0'),
  };
}

export function guideRunbookForRoute(route) {
  const slug = route.path === '/guides'
    ? 'guides'
    : route.path.startsWith('/guides/') ? route.path.slice('/guides/'.length) : null;

  if (!slug) return null;

  const sections = route.content.sections.map((section, index) => ({
    ...guideSectionPresentation(section.heading, index),
    section,
  }));
  const navItems = [
    ...sections.map(({ heading, id }) => ({ heading, id })),
    ...(route.content.cards ? [{ heading: 'Explore related paths', id: 'guide-related-paths' }] : []),
    ...(route.content.faq ? [{ heading: 'Frequently asked questions', id: 'guide-frequently-asked-questions' }] : []),
  ];

  return {
    navItems,
    reviewedAt: route.content.verifiedAt || route.lastmod,
    sections,
    slug,
  };
}
